import { combineReducers } from '@reduxjs/toolkit'
import { reducer as formReducer } from 'redux-form'
import { reducer as goods } from 'src/slices/goods'
import { reducer as ordersReducer } from 'src/slices/orders'
import { reducer as cargoPackage } from 'src/slices/cargo-package'
import { reducer as parcelsReducer } from 'src/slices/parcels'
import { reducer as calendarReducer } from 'src/slices/calendar'
import { reducer as chatReducer } from 'src/slices/chat'
import { reducer as dynamicNavigationReducer } from 'src/slices/dynamic-navigation'
import { reducer as kanbanReducer } from 'src/slices/kanban'
import { reducer as mailReducer } from 'src/slices/mail'
import { reducer as notificationReducer } from 'src/slices/notification'
import { reducer as fetchTableResults } from 'src/slices/fetchTableResults/index.js'
import { reducer as clientReducer } from 'src/slices/clients'
import { reducer as registry } from 'src/slices/registry'
import { reducer as shipmentReducer } from 'src/slices/shipment'
import { reducer as pvz } from 'src/slices/pvz'
import tasks from 'src/slices/tasks'

const rootReducer = combineReducers({
  goods: goods,
  orders: ordersReducer,
  parcels: parcelsReducer,
  calendar: calendarReducer,
  chat: chatReducer,
  form: formReducer,
  kanban: kanbanReducer,
  mail: mailReducer,
  notifications: notificationReducer,
  navigationState: dynamicNavigationReducer,
  fetchTableResults: fetchTableResults,
  shipment: shipmentReducer,
  clients: clientReducer,
  tasks,
  cargoPackage,
  registry,
  pvz,
})

export default rootReducer
